import script from "./recommend-card.vue?vue&type=script&setup=true&lang=js"
export * from "./recommend-card.vue?vue&type=script&setup=true&lang=js"

import "./recommend-card.vue?vue&type=style&index=0&id=5c7b2764&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7b2764"]])

export default __exports__